import React from 'react';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { VariableInputControlSlot } from '../VariableInputControlSlot';

export const Variables = ({ variables }: Props) => (
    <>
        {variables.map(variable => (
            <VariableInputControlSlot
                key={variable.id}
                variableIds={[variable.id]}
                render={(Control) => (<Cell><Control /></Cell>)} />
        ))}
    </>
);

type Props = {
    variables: GiftJson.Variable<any>[];
};